<template>
  <div class="json-view-main">
    <div class="block_content">
      <draggable v-model="flowData" handle=".dragbar" @end="onDragEnd">
        <div
          v-for="(item, index) in flowData"
          :key="`${item.type}${index}`"
          :class="['block', 'clearfix', {'hide-block': hideMyBlock[index] === true}]"
        >
          <span class="json-key">
            <input
              type="text"
              v-model="item.name"
              class="key-input"
              v-if="typeof item.name == 'string'"
              @blur="keyInputBlur(item, $event)"
            />
            <i
              class="collapse-down fa fa-sort-down"
              v-if="item.type === 'object' || item.type === 'array'"
              @click="closeBlock(index, $event)"
            />
            <i v-if="item.type === 'object'" class="i-type">{{'{' + item.childParams.length + '}'}}</i>
            <i v-if="item.type === 'array'" class="i-type">{{'[' + item.childParams.length + ']'}}</i>
          </span>
          <span class="json-val">
            <template v-if="item.type === 'object'">
              <json-view :parsedData="item.childParams" v-model="item.childParams" />
            </template>

            <template v-else-if="item.type === 'array'">
              <array-view :parsedData="item.childParams" v-model="item.childParams" />
            </template>

            <template v-else>
              <span class="val">
                默认值：
                <input
                  type="text"
                  v-model="item.remark"
                  class="val-input"
                  v-if="item.type === 'string'"
                  :disabled="item.disabled"
                  :placeholder="item.placeholder ? item.placeholder : ''"
                />
                <input
                  type="number"
                  v-model.number="item.remark"
                  class="val-input"
                  v-if="item.type === 'int'"
                  @input="numberInputChange(item)"
                  :disabled="item.disabled"
                />
                <select
                  name="value"
                  v-model="item.remark"
                  class="val-input"
                  v-if="item.type === 'boolean'"
                  :disabled="item.disabled"
                >
                  <option :value="true" selected>true</option>
                  <option :value="false">false</option>
                </select>
                <input
                  type="text"
                  v-model="item.remark"
                  class="val-input"
                  v-if="item.type === 'unicode'"
                  :disabled="item.disabled"
                />
                <input
                  type="date"
                  v-model="item.remark"
                  class="val-input"
                  v-if="item.type === 'datetime'"
                  :disabled="item.disabled"
                />
                描述：
                <input
                  type="text"
                  v-model="item.desc"
                  class="val-input"
                  :disabled="item.disabled"
                />
                <template v-if="item.type !== 'boolean'">
                  <template v-if="item.type === 'datetime'">
                    日期范围：
                    <input
                      type="date"
                      v-model="item.range[0]"
                      class="val-input"
                      v-if="item.type === 'datetime'"
                      @change="firstRangeChange(item)"
                      :disabled="item.disabled"
                    /> -
                    <input
                      type="date"
                      v-model="item.range[1]"
                      class="val-input"
                      v-if="item.type === 'datetime'"
                      :min="item.range[0]"
                      :disabled="item.disabled"
                    />
                  </template>
                  <template v-else>
                    正则：
                    <input
                      type="text"
                      v-model="item.re"
                      class="val-input"
                      :placeholder="reDefault[item.type]"
                      :disabled="item.disabled"
                    />
                  </template>
                  <input type="checkbox" v-model="item.required" :checked="item.required" /> 必填项
                </template>
              </span>
            </template>
          </span>

          <div class="tools">
            <select v-model="item.type" class="tools-types" @change="itemTypeChange(item)" :disabled="item.banOp">
              <option v-for="(type, index) in formats" :value="type" :key="index">{{type}}</option>
            </select>
            <i class="dragbar fa fa-list" v-if="!item.banOp" />
            <i class="del-btn" @click="delItem(parsedData, item, index)" v-if="!item.banOp">
              <i class="fa fa-trash-o" />
            </i>
          </div>
        </div>

        <item-add-form v-if="toAddItem" @confirm="newItem" @cancel="cancelNewItem" />

        <div class="block add-key" @click="addItem" v-if="!toAddItem">
          <i class="fa fa-plus" />
        </div>
      </draggable>
    </div>
  </div>
</template>

<script>
import ItemAddForm from './ItemAddForm.vue'

export default {
  name: 'json-view',
  props: { parsedData: [] },
  data () {
    return {
      formats: ['string', 'array', 'object', 'int', 'boolean', 'datetime', 'unicode'],
      flowData: this.parsedData,
      toAddItem: false,
      hideMyBlock: {},
      reDefault: {
        int: '^[\\d]{1,10}$',
        string: '^[\\w\\W]{0,20}$',
        unicode: '^[\\w\\W]{0,20}$'
      }
    }
  },
  created () {
    this.flowData = this.parsedData || []
  },
  watch: {
    parsedData: {
      handler (newValue, oldValue) {
        this.flowData = this.parsedData
      }
    }
  },
  components: {
    'item-add-form': ItemAddForm,
    'array-view': () => import('./ArrayView.vue')
  },
  methods: {
    delItem (parentDom, item, index) {
      this.flowData.splice(index, 1)
      if (this.hideMyBlock[index]) this.hideMyBlock[index] = false
      this.$emit('input', this.flowData)
    },
    closeBlock (index, e) {
      this.$set(
        this.hideMyBlock,
        index,
        !this.hideMyBlock[index]
      )
    },
    addItem () {
      this.toAddItem = true
    },
    cancelNewItem () {
      this.toAddItem = false
    },
    newItem (obj) {
      let oj = {
        name: obj.key,
        type: obj.type,
        desc: obj.desc,
        required: obj.required
      }
      if (obj.type === 'array' || obj.type === 'object') {
        oj.childParams = obj.val
        oj.remark = null
      } else {
        oj.childParams = null
        oj.remark = obj.val
      }
      if (obj.type !== 'array' && obj.type !== 'object' && obj.type !== 'boolean') {
        if (obj.type === 'datetime') {
          oj.range = obj.range
        } else {
          oj.re = obj.re
        }
      }
      if (!oj.name) {
        alert('please must input a name!')
      } else {
        this.flowData.push(oj)
        this.$emit('input', this.flowData)
        this.cancelNewItem()
      }
    },
    keyInputBlur (item, e) {
      if (item.name.length <= 0) {
        alert('please must input a name!')
        item.name = 'null'
        e.target.focus()
      }
    },
    onDragEnd () {
      this.$emit('input', this.flowData)
    },
    itemTypeChange (item) {
      if (item.type === 'array' || item.type === 'object') {
        item.childParams = []
        item.remark = null
      } else {
        item.desc = ''
        if (item.type !== 'boolean') {
          item.re = ''
        }
      }
      if (item.type === 'boolean') {
        item.remark = true
      }
      if (item.type === 'string') {
        item.remark = ''
      }
      if (item.type === 'int') {
        item.remark = 0
      }
      if (item.type === 'datetime') {
        item.range = ['', '']
      }
    },
    numberInputChange (item) {
      if (!item.remark) item.remark = 0
    },
    firstRangeChange (item) {
      if (item.range[0] && item.range[1] && item.range[0] > item.range[1]) {
        item.range[1] = ''
      }
    }
  }
}
</script>

<style>
  .block {
    position: relative;
    display: block;
    line-height: 20px;
    margin-bottom: 5px;
  }
  .json-key {
    font-weight: bold;
  }
  .block_content .val-input {
    font-weight: normal !important;
    color: #0b8e6b;
    width: 12% !important;
  }
  .tools {
    position: absolute;
    right: 20px;
    top: 0;
    height: 30px;
  }
  .block_content {
    text-align: left;
    margin-left: 20px;
    line-height: 1.5 !important;
  }
  .pure-form input {
    padding: 0.5em 0.6em;
    display: inline-block;
    border: 1px solid #ccc;
    box-shadow: inset 0 1px 3px #ddd;
    border-radius: 4px;
    vertical-align: middle;
    box-sizing: border-box;
  }
  .dragbar {
    position: absolute;
    top: 3px;
    right: 20px;
    bottom: 0;
    width: 5px;
    font-size: 18px;
    margin-right: 15px;
    cursor: pointer;
  }
  .tools-types {
    position: relative;
    right: 50px;
  }
  .del-btn {
    right: 5px;
    position: absolute;
    bottom: 0;
  }
  .add-key {
    display: inline-block;
    padding-left: 2px;
    padding-right: 2px;
    margin-bottom: 10px;
    font-size: 0.8em;
    line-height: 1em;
    cursor: pointer;
  }
  .block_content .key-input, .block_content .val-input {
    width: 140px;
    border: none;
    height: 25px;
    padding: 0 5px;
    font-weight: bold;
    font-size: 14px;
    background: rgba(0, 0, 0, 0);
  }
  .block_content .i-type {
    color: #999;
  }
  .collapse-down {
    float: left;
    color: #000;
    cursor: pointer;
    transition: transform 0.2s ease;
  }
  .block.hide-block {
    background: #f5f5f5;
  }
  .array-ol {
    padding-left: 20px !important;
  }
  .array-item {
    position: relative;
  }
  .ol {
    margin: 0;
    display: block;
    list-style-type: decimal;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0;
    margin-inline-end: 0;
    padding-inline-start: 40px;
  }
  .block_content .json-key.json-desc {
    color: #999;
    font-size: 0.8em;
  }
  .block.hide-block .collapse-down {
    transform: rotate(-90deg);
  }
  .block.hide-block .json-val {
    display: none;
  }
  .f-confirm {
    color: #fff;
    background: #05a5d1;
  }
  .array-item.hide-item .json-val {
    display: none;
  }
  .array-item.hide-item {
    background: #f5f5f5;
  }
  .array-item.hide-item .collapse-down {
    transform: rotate(-90deg);
  }
  .array-item .collapse-down {
    top: -2px;
    position: relative;
    margin-right: -10px;
  }
  .type-identity {
    margin-left: 15px;
  }
</style>



// WEBPACK FOOTER //
// JsonView.vue?925f4a58